import React from "react";

//icons
import { IconLibrary } from "../../../interfaces/icon/IconLibrary";
import Icon from "../icons/Icon";

//interfaces
import { IMenuButton } from "../../../interfaces/buttons/buttons";


const MenuButton = ({isDisabled, ariaLabel, onButtonClick}: IMenuButton) => {

    return (
        <button
            className={`menu-button`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
        >
            <Icon iconName={IconLibrary.MENU_MORE} sizeInPx="12" color="var(--thriveLightSlate)"/>
        </button>
    );
};

export default MenuButton